// PROD-1077: the ONE patient-side reader of a physician's note hold.
//
// The hold is per encounter (md md_encounter_note_hold writes encounters.note_hold). The API
// (lane a1077) blanks a held row's consult note for a patient and sets `noteHeld: true|false` on
// every row; an older API sends only the raw `note_hold`. Every screen asks this function, so
// they cannot disagree. The case-level envelope's `noteDelivery` is NOT the record and is never
// read (it never reached the app: the old MyMedicalNote reader of it was dead).
//
// ★ NO IMPORTS. scripts/check-note-hold-per-encounter.mjs runs it in node. It logs nothing.

/** True when the physician holds this encounter's consult note from the patient. */
export function isEncounterNoteHeld(enc) {
  return enc?.noteHeld === true || enc?.note_hold === true
}
